import { render } from "./OtherMetrics.html?vue&type=template&id=77148e25"
import script from "./OtherMetrics.js?vue&type=script&lang=js"
export * from "./OtherMetrics.js?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__